import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getStudentGuardians, addConversationMember, removeConversationMember } from 'actions/conversation';
import Modal from 'containers/Modals/Modal';
import { Spinner } from 'UI';
import { Button, Checkbox, translate } from '@haldor/ui';
var GuardianMembershipModal = /*#__PURE__*/function (_Component) {
  function GuardianMembershipModal(props) {
    var _this;
    _classCallCheck(this, GuardianMembershipModal);
    _this = _callSuper(this, GuardianMembershipModal, [props]);
    _defineProperty(_this, "getCurrentMembers", function () {
      // Get current members based on mode (draft or normal)
      if (_this.props.draftGuardians != null) {
        return _this.props.draftGuardians.map(function (g) {
          return g.id;
        });
      }
      var conversation = _this.props.conversation;
      if (conversation == null || conversation.memberships == null) {
        return [];
      }
      return conversation.memberships.filter(function (m) {
        return m.membershipType === 'GUARDIAN';
      }).map(function (m) {
        return m.membershipID;
      });
    });
    _defineProperty(_this, "isGuardianMember", function (guardianId) {
      // Draft mode: check against provided draftGuardians array or if current user
      if (_this.props.draftGuardians != null) {
        var isCurrentUser = _this.props.user != null && guardianId === _this.props.user.id;
        var isInDraft = _this.props.draftGuardians.some(function (g) {
          return g.id === guardianId;
        });
        return isCurrentUser || isInDraft;
      }
      var conversation = _this.props.conversation;
      if (conversation == null || conversation.memberships == null) {
        return false;
      }
      return conversation.memberships.some(function (m) {
        return m.membershipID === guardianId && m.membershipType === 'GUARDIAN';
      });
    });
    _defineProperty(_this, "onToggleGuardian", function (guardian) {
      // Draft mode: delegate to parent callback without API calls
      if (_this.props.draftGuardians != null && _this.props.onDraftToggle != null) {
        _this.props.onDraftToggle(guardian);
        return;
      }
      var conversation = _this.props.conversation;
      var isMember = _this.isGuardianMember(guardian.id);
      _this.setState({
        submitting: true
      });
      if (isMember) {
        var existing = conversation.memberships.find(function (m) {
          return m.membershipID === guardian.id && m.membershipType === 'GUARDIAN';
        });
        _this.props.removeConversationMember(existing.id, guardian.id).then(function () {
          _this.setState({
            submitting: false
          });
        });
      } else {
        _this.props.addConversationMember({
          conversationId: conversation.id,
          membershipID: guardian.id,
          membershipType: 'GUARDIAN',
          permission: 'W',
          user: {
            id: guardian.id,
            firstName: guardian.firstName,
            lastName: guardian.lastName
          }
        }).then(function () {
          _this.setState({
            submitting: false
          });
        });
      }
    });
    _defineProperty(_this, "renderGuardianList", function () {
      var _this$props = _this.props,
        studentGuardians = _this$props.studentGuardians,
        translate = _this$props.translate;
      var _this$state = _this.state,
        submitting = _this$state.submitting,
        initialMembers = _this$state.initialMembers;
      if (studentGuardians == null || studentGuardians.length === 0) {
        return /*#__PURE__*/React.createElement("p", null, translate('No guardians found'));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "guardian-membership-list"
      }, studentGuardians.map(function (guardian) {
        var isMember = _this.isGuardianMember(guardian.id);
        var isCurrentUser = _this.props.user != null && guardian.id === _this.props.user.id;
        var isDraftMode = _this.props.draftGuardians != null;
        var isInitialMember = initialMembers.includes(guardian.id);
        // Disable if: submitting, current user, OR initial member (cannot be removed)
        var isDisabled = submitting || isCurrentUser && (isMember || isDraftMode) || isInitialMember && isMember;
        return /*#__PURE__*/React.createElement("div", {
          className: "guardian-membership-item",
          key: guardian.id
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: isMember,
          label: guardian.firstName + ' ' + guardian.lastName,
          onChange: function onChange() {
            return _this.onToggleGuardian(guardian);
          },
          disabled: isDisabled
        }));
      }));
    });
    _this.state = {
      loading: true,
      submitting: false,
      initialMembers: [] // Track guardians that were members when modal opened
    };
    return _this;
  }
  _inherits(GuardianMembershipModal, _Component);
  return _createClass(GuardianMembershipModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var activeStudent = this.props.activeStudent;
      if (activeStudent != null) {
        this.props.getStudentGuardians(activeStudent.id).then(function () {
          // Store the current members as initial members
          var initialMembers = _this2.getCurrentMembers();
          _this2.setState({
            loading: false,
            initialMembers: initialMembers
          });
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Clear initialMembers when modal closes
      if (prevProps.isOpen && !this.props.isOpen) {
        this.setState({
          initialMembers: []
        });
      }

      // Refresh initialMembers when modal opens
      if (!prevProps.isOpen && this.props.isOpen) {
        var initialMembers = this.getCurrentMembers();
        this.setState({
          initialMembers: initialMembers
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        isOpen = _this$props2.isOpen,
        onClose = _this$props2.onClose,
        translate = _this$props2.translate;
      var loading = this.state.loading;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: isOpen,
        onClose: onClose,
        title: translate('Manage participants'),
        type: "small",
        overridePrompt: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "guardian-membership-modal"
      }, loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.renderGuardianList(), /*#__PURE__*/React.createElement("div", {
        className: "guardian-membership-actions"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: onClose
      }, translate('Close')))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    studentGuardians: state.Conversation.studentGuardians,
    activeStudent: state.User.activeStudent,
    user: state.User.user,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getStudentGuardians: getStudentGuardians,
  addConversationMember: addConversationMember,
  removeConversationMember: removeConversationMember
})(GuardianMembershipModal);